type PlaybackOpts = {
  playbackUrl?: string | null;
  playbackId?: string | null;
  playbackPolicy?: ('signed' | 'public') | null;
};

export const getHlsUrl = (opts: PlaybackOpts): string | null => {
  if (opts.playbackUrl) return opts.playbackUrl;
  if (opts.playbackId && opts.playbackPolicy !== 'signed') {
    return `https://stream.mux.com/${opts.playbackId}.m3u8`;
  }
  return null;
};

type PosterOpts = PlaybackOpts & {
  posterUrl?: string | null;
  posterTimestamp?: number | null;
};

export const getPosterUrl = (opts: PosterOpts): string | undefined => {
  if (opts.posterUrl) return opts.posterUrl;
  if (opts.playbackId && opts.playbackPolicy !== 'signed') {
    const base = `https://image.mux.com/${opts.playbackId}/thumbnail.jpg`;
    return typeof opts.posterTimestamp === 'number' ? `${base}?time=${opts.posterTimestamp}` : base;
  }
  return undefined;
};

export const secondsToISO8601Duration = (seconds: number): string => {
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  let out = 'PT';
  if (hours) out += `${hours}H`;
  if (minutes) out += `${minutes}M`;
  if (secs || (!hours && !minutes)) out += `${secs}S`;
  return out;
};

export const normalizeAspectRatio = (raw: string | null | undefined): string | undefined => {
  if (!raw) return undefined;
  const match = raw.trim().match(/^(\d+(?:\.\d+)?)\s*[:/]\s*(\d+(?:\.\d+)?)$/);
  if (!match) return undefined;
  return `${match[1]} / ${match[2]}`;
};
